import { OrderDetailsSchema, OrderSchema } from 'api/types/data';
import { OrderOperationType } from 'api/types/entity/order';

const parseDetails = (detailsSchema: OrderDetailsSchema | undefined) => ({
  brokerName: detailsSchema?.brokerName
    ? {
        value: detailsSchema.brokerName.referenceRecordId,
        label: detailsSchema.brokerName.value,
      }
    : undefined,
});

export const getOrderInitialValues = (
  orderType: OrderOperationType,
  orderSchema: OrderSchema | undefined
) => {
  const initialValues = {
    senderDetails:
      orderType === OrderOperationType.SecuritiesWithdrawal
        ? parseDetails(orderSchema?.senderDetails)
        : undefined,

    recipientDetails:
      orderType === OrderOperationType.SecuritiesDeposit
        ? parseDetails(orderSchema?.recipientDetails)
        : undefined,
  };

  return initialValues;
};
